module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0037.jpg?v=001316b8";